// extracted by mini-css-extract-plugin
module.exports = {"MedKitTheme":"appointments__ServiceMix__MedKitTheme"};